import {Wheel} from '../types/Wheel';

export const EMPTY_WHEEL: Partial<Wheel> = {
  checked: true,
};
